<template>
  <div class="register">
    <div class="text">
      <h1 class="blueTitle">Stay Informed</h1>
      <p>For the latest news on the project, please sign up below</p>
    </div>
    <div class="submitbox">
      <div class="imageHalf">
        <div
          :style="{
            'background-image': `url(${require('@/assets/images/SitePhotograph.jpg')})`,
          }"
        ></div>
      </div>
      <div class="formHalf">
        <div>
          <form class="contact-form" @submit.prevent="sendEmail">
            <div class="formEl nameInput">
              <div class="textlabel">
                <label>Your name*</label>
              </div>
              <div class="name">
                <input
                  class="text"
                  type="text"
                  name="name"
                  placeholder="enter your name…"
                />
              </div>
            </div>

            <div class="formEl emailInput">
              <div class="textlabel">
                <label>Your email*</label>
              </div>
              <div class="email">
                <input
                  class="text"
                  type="email"
                  name="email"
                  placeholder="enter your email address…"
                />
              </div>
            </div>

            <div class="formEl recieveCheck">
              <input
                class="checkbox"
                type="checkbox"
                name="recieve"
                value="Agree"
              />
              <label style="padding-left: 10px"
                >I would like to recieve email updates.
              </label>
            </div>
            <div class="formEl">
              <input class="submit" type="submit" name="submit" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "Register",
  methods: {
    sendEmail: (email) => {
      emailjs
        .sendForm(
          "service_4f4puun",
          "template_ij0vc2o",
          email.target,
          "user_1tTjOBaELSKCj1osqoOQT"
        )
        .then(
          (result) => {
            console.log("Email Sent ", result.status, result.text);
          },
          (error) => {
            console.log("Email Failed ", error);
          }
        );
    },
  },
};
</script>